export default __webpack_public_path__ + "static/media/days_to_remember.d4fbab73.png";